/**
 * 檔案用途區塊
 * @module device-platform.enum
 * @purpose 定義裝置平台與瀏覽器識別所需的列舉值，供 UA 解析與環境判斷流程共用。
 * @external https://innotech.atlassian.net/browse/IN-63960
 */

/**
 * 宣告內容用途說明與單號關聯
 * @description 裝置平台列舉，統一描述作業系統或執行環境類型。
 * @purpose 提供跨模組可重用的平台分類常數，避免字串比對分散。
 */
export enum DevicePlatform {
  'Windows',
  'Android',
  'Mac',
  'Ios',
  'Linux',
  'Unknown',
}

/**
 * 宣告內容用途說明與單號關聯
 * @description 瀏覽器列舉，統一描述前端執行時偵測到的瀏覽器類型。
 * @purpose 作為 UA 解析後的標準化輸出值，便於條件分流與紀錄。
 */
export enum Browser {
  'Edge',
  'Firefox',
  'Safari',
  'Chrome',
  'Unknown',
}

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:21:55.328Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotations (top/middle/bottom), included top-level external Jira link from file history ticket IN-63960, added declaration comments without @external due to empty declarationOrigins, and kept runtime logic unchanged.
 */
